import React from 'react';
import { useLanguage } from '../../store/language-context';

const LocalSpeakerCard = ({ name, title, image }) => {
    const { language } = useLanguage();
    
    return (
        <div className="bg-white rounded-lg p-6 shadow-md mx-2 flex flex-col items-center">
            {/* Speaker Image */}
            <div className="w-32 h-32 mb-4 overflow-hidden rounded-full">
                <img 
                    src={image} 
                    alt={name}
                    className="w-full h-full object-cover"
                />
            </div>
            
            {/* Speaker Info */}
            <div className="text-center">
                <h3 className={`text-xl font-bold text-primary mb-2 ${language === 'ar' ? 'font-arabic' : ''}`}>
                    {name}
                </h3>
                <p className={`text-sm text-gray-600 ${language === 'ar' ? 'font-arabic' : ''}`}>
                    {title}
                </p>
            </div>
        </div>
    );
};

export default LocalSpeakerCard;
